<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card v-if="!!persona">
      <v-card-title class="headline ma-0">
        <v-icon>person</v-icon> Ver persona
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        class="contenedor-persona"
        color="grey lighten-4"
        elevation="4"
      >
        <v-container fluid grid-list-md class="pa-0" style="min-width:100%">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card-text class="contenedor-foto">
                <v-avatar
                  :color="foto ? '#FFF' : 'light-blue darken-4'"
                  size="200"
                >
                  <v-img
                    v-if="foto"
                    :aspect-ratio="16 / 9"
                    :src="foto"
                    max-height="250"
                    max-width="250%"
                    min-height="200"
                    min-width="200"
                    @error="handleImageError()"
                  >
                  </v-img>
                  <span v-else class="white--text display-2">{{
                    !!persona.nombres ? persona.nombres[0] : "-"
                  }}</span>
                </v-avatar>
              </v-card-text>
            </v-flex>
            <v-flex xs12 md6 style="height:100%;">
              <v-card-text class="mt-3 mb-0 pt-0 pb-0 text-xs-center">
                <h4
                  class="font-weight-bold blue--text m-0"
                  style="font-size:1.5rem"
                >
                  {{ persona.ap_paterno }} {{ persona.ap_materno }}
                  {{ persona.nombres }}
                </h4>
                <h4 class="font-weight-light " style="font-size:1.1em">
                  <b>C.I.:</b>{{ persona.nro_doc }}
                </h4>
                <table class="table-datos-personales">
                  <tr v-for="dato in l_datos_personales" :key="dato.key">
                    <td>
                      <v-btn dark small icon color="primary" outline>
                        <span class="material-symbols-outlined">
                          {{ dato.icon }}
                        </span>
                      </v-btn>
                    </td>
                    <td>
                      <span class="titulo-personal font-weight-bold blue--text">
                        {{ dato.label }}
                      </span>
                      <br />
                      <span class="subtitulo-personal">
                        {{ persona[dato.key] }}
                      </span>
                    </td>
                  </tr>
                </table>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      user: this.$storage.get("user"),
      persona: {},
      valid: false,
      loading: false,
      api_backend: process.env.API_URL.split("api/")[0],
      foto: null,
      l_datos_personales: [
        {
          icon: "badge",
          label: "Nro item",
          key: "nro_item"
        },
        {
          icon: "domain",
          label: "Unidad",
          key: "nombre_unidad"
        },
        {
          icon: "engineering",
          label: "Cargo",
          key: "cargo"
        },
        {
          icon: "assignment_ind",
          label: "Puesto",
          key: "puesto"
        },
        {
          icon: "badge",
          label: "C.I:",
          key: "nro_doc"
        }
      ]
    };
  },
  async mounted() {
    this.$bus.$on("openDialogVerDatosPersona", async item => {
      this.persona = item;
      if (this.persona.foto) {
        this.foto = this.api_backend + this.persona.foto;
      } else {
        this.foto = ""; //require("../../../../assets/images/camara.jpg");
      }
      this.dialog = true;
    });
  },

  methods: {
    close() {
      this.dialog = false;
      this.persona = {};
      this.loading = false;
      this.valid = false;

      this.$bus.$emit("closeDialogVerDatosPersona");
    },
    handleImageError() {
      this.foto = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.contenedor-persona {
  line-height: 0.9;
  .contenedor-foto {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .table-datos-personales {
    text-align: left;
    td {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reportes_lista_personal/dialogs/VerDetallePersona.vue